module.exports = __webpack_public_path__ + "img/9788997889549.e279dc65.jpg";